<template>
  <div class="bb-contact-form-mailing-item">
    <div class="bb-contact-form-mailing-item__wrap">
      <div class="bb-contact-form-mailing-item__image">
        <img :src="image"/>
      </div>
      <div class="bb-contact-form-mailing-item-contacts">
        <div class="bb-contact-form-mailing-item-contacts__name">
          {{item.username || item.userName }}
        </div>
        <div class="bb-contact-form-mailing-item-contacts__email">
          {{item.email}}
        </div>
      </div>
    </div>
    <div
      class="bb-contact-form-mailing-item__disconnect"
      @click="onDisconnect"
    >
      Disconnect
    </div>
  </div>
</template>

<script>
import avatarUserDefault from '@/assets/images/avatar-user-default.png'

export default {
  name: 'ContactFormMailingItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    image () {
      const { image } = this.item
      return image || avatarUserDefault
    }
  },
  methods: {
    onDisconnect () {
      this.$emit('onDisconnect', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

  .bb-contact-form-mailing-item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & + & {
      margin: 16px 0 0 0;
    }

    &__wrap {
      display: flex;
      grid-gap: 0 8px;
    }

    &__image {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    &__disconnect {
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      color: $color-denim;
      text-decoration: underline;
      cursor: pointer;
      transition: 0.2s;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .bb-contact-form-mailing-item-contacts {
    display: grid;
    grid-gap: 1px 0;

    &__name {
      font-weight: 400;
      font-size: 12px;
      color: $color-black;
      text-transform: capitalize;
    }

    &__email {
      font-weight: 400;
      font-size: 12px;
      color: $color-silver-chalice;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Companies/CompanyForm/ContactFormMailing/ContactFormMailingItem.vue